import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router-dom'
import { Container, Col, Row } from 'react-bootstrap'
import { Paper } from '@mui/material'

import DataTable from 'Shared/Components/DataTable'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'

const AccessControl = () => {
  const { setPageLoading } = useOutletContext()
  const { t } = useTranslation()
  const { send } = useFetchData()

  const tableRef = useRef()
  const [data, setData] = useState({ "data": null, "count": 0 })

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/access_control/records`,
      params: {
        "page": tableRef.current.getState()["page"]-1,
        "limit": tableRef.current.getState()["itemsPerPage"]
      },
      returnType: "json"
    })

    body && setData({
      "data": body["data"].map((i) =>( {
        "worker_name": i["worker_name"],
        "datetime": i["datetime"],
        "result": i["result"],
        // "pic": i["pic"] ? <img alt="pic" src={i["pic"]} style={{ width: "80px" }}/> : null
      })),
      "count": body["count"]
    })
  }
  
  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  const reload = async () => {
    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={data["data"]} count={data["count"]} loadData={() => reload()} ref={tableRef}
              columns={{
                "worker_name": { "label": t("general_workerName"), "sorting": false, "nowrap": true },
                "datetime": { "label": t("general_datetime"), "sorting": false, "nowrap": true },
                "result": { "label": t("general_result"), "sorting": false, "nowrap": true },
                // "pic": { "label": t("accessControl_picture"), "sorting": false, "nowrap": true },
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 
  </>)
}

export default AccessControl
